<div class="find-tracks__search">
  <mat-form-field appearance="outline">
    <mat-label>{{ lg.sortTrackBy.beatmaker.label }}</mat-label>
    <div class="find-tracks__input-box">
      <input
        matInput
        type="text"
        [(ngModel)]="searchBeatmakerTitle"
        (focus)="closeTagDropdown()"
        (ngModelChange)="changeBeatmakerValue({ search: $event, searchType: 'beatmaker' })"
      />
      @if (searchBeatmakerTitle) {
        <span class="btv-icon-close" (click)="clearBeatmakerField()"></span>
      }
    </div>
  </mat-form-field>

  <!-- Beatmaker search result dropdown -->
  @if (isBeatmakerDropdown) {
    <div class="find-tracks__response bm--scroll-bar">
      @for (beatmaker of beatmakers; track beatmaker) {
        <ul>
          @if (beatmaker.value !== 'битмейкер не найден') {
            <li class="beatmaker-li" (click)="findTracksByBeatmakerName(beatmaker.id, beatmaker.value)">
              {{ beatmaker.value }}
            </li>
          }
          @if (beatmaker.value === 'битмейкер не найден') {
            <li class="not-found">
              {{ lg.sortTrackBy.beatmaker.notFound }}
            </li>
          }
        </ul>
      }
    </div>
  }
</div>
